<span [class]="isDark?'dark':''"
      *ngIf="summaryBuyValue&&summarySellValue
      &&(summaryBuyValue.selectionCount+summarySellValue.selectionCount>0||summaryBuyValue.selectionCount+summarySellValue.selectionCount<0)">
  <span *ngIf="owner">
    <span
      class="selection-value"
    >
<!--      Owner: -->
      {{owner}}</span>
    <span class="selection-separator">-</span>
  </span>
  <span *ngIf="summaryBuyValue.selectionCount+summarySellValue.selectionCount>1"
    class="selection-value selection-count">Selected: {{summaryBuyValue.selectionCount + summarySellValue.selectionCount}}</span>
    <span *ngIf="summaryBuyValue.totalVolume + summarySellValue.totalVolume>0" class="selection-separator selection-separator">|</span>
  <span *ngIf="summaryBuyValue.totalVolume + summarySellValue.totalVolume>0"
    class="selection-value selection-volume">Sum: {{summaryBuyValue.totalVolume + summarySellValue.totalVolume}}</span>
  <span *ngIf="summaryBuyValue.totalVolume>0">
    <span  class="selection-separator selection-volume-separator">|</span>
    <span class="selection-value selection-volume-buy">Buy: {{summaryBuyValue.totalVolume}}</span>
  </span>
  <span *ngIf="summarySellValue.totalVolume>0">
    <span class="selection-separator selection-volume-separator">|</span>
    <span class="selection-value selection-volume-sell">Sell: {{summarySellValue.totalVolume}}</span>
  </span>
  <span *ngIf="summaryBuyValue.totalPrice/summaryBuyValue.totalVolume>0">
    <span class="selection-separator selection-separator">|</span>
    <span
      class="selection-value selection-avg-buy" [pTooltip]="'page.clearing.summary.AvgBuy'|translate"
    >AvgBuy: {{(summaryBuyValue.totalPrice / summaryBuyValue.totalVolume) | number: '1.0-'+averagePriceDecimal}}</span>
  </span>
  <span *ngIf="summarySellValue.totalPrice/summarySellValue.totalVolume>0">
    <span class="selection-separator selection-avg-separator">|</span>
    <span
      class="selection-value selection-avg-sell" [pTooltip]="'page.clearing.summary.AvgSell'|translate"
    >AvgSell: {{(summarySellValue.totalPrice / summarySellValue.totalVolume) | number: '1.0-'+averagePriceDecimal}}</span>
  </span>
  <span *ngIf="summaryBuyValue.apsGrpTotalPrice/summaryBuyValue.apsGrpTotalPrice>0">
    <span class="selection-separator selection-separator">|</span>
    <span
      class="selection-value selection-aps-buy" [pTooltip]="'page.clearing.summary.ApsBuy'|translate"
    >ApsBuy: {{(summaryBuyValue.apsGrpTotalPrice / summaryBuyValue.apsGrpTotalVolume) | number: '1.0-'+averagePriceDecimal}}</span>
  </span>
  <span *ngIf="summarySellValue.apsGrpTotalPrice/summarySellValue.apsGrpTotalPrice>0">
    <span class="selection-separator selection-aps-separator">|</span>
    <span
      class="selection-value selection-aps-sell" [pTooltip]="'page.clearing.summary.ApsSell'|translate"
    >ApsSell: {{(summarySellValue.apsGrpTotalPrice / summarySellValue.apsGrpTotalVolume) | number: '1.0-'+averagePriceDecimal}}</span>
  </span>
</span>
<p-progressSpinner
  *ngIf="showLoadingSpinner&&summaryBuyValue&&summarySellValue&&summaryBuyValue.selectionCount+summarySellValue.selectionCount==0"
  class="cc-spinner-sm" strokeWidth="5"
  fill="transparent" animationDuration="0.8s"></p-progressSpinner>
